import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TestimonialsSection = ({ heading = "What clients say", limit }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/testimonials`).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (items.length === 0) return null;
  const list = limit ? items.slice(0, limit) : items;
  const cols = list.length === 1 ? "md:grid-cols-1 max-w-xl" : list.length === 2 ? "md:grid-cols-2" : "md:grid-cols-2 lg:grid-cols-3";

  return (
    <div data-testid="testimonials-section">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#D94833]">Social proof</p>
      <h2 className="font-head text-4xl sm:text-5xl leading-[1.1] tracking-tight font-bold mt-4 max-w-3xl text-[#041C3E]">
        {heading}
      </h2>
      <div className={`grid grid-cols-1 ${cols} gap-px bg-[#E5E7EB] border border-[#E5E7EB] mt-12`}>
        {list.map((t, i) => (
          <motion.div
            key={t.id}
            data-testid={`testimonial-card-${t.id}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
            className="bg-white p-8 flex flex-col"
          >
            <Quote size={22} className="text-[#D94833]" />
            <p className="text-[#162030] leading-relaxed mt-4 flex-1">{t.quote}</p>
            {(t.name || t.role) && (
              <div className="mt-6 pt-4 border-t border-[#F3F4F6]">
                {t.name && <p className="text-sm font-bold text-[#041C3E]">{t.name}</p>}
                {t.role && <p className="text-xs font-semibold text-[#9CA3AF] uppercase tracking-[0.12em] mt-1">{t.role}</p>}
              </div>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
};
